import { render, staticRenderFns } from "./FilterSalary.vue?vue&type=template&id=0acb28b3&scoped=true"
import script from "./FilterSalary.vue?vue&type=script&lang=js"
export * from "./FilterSalary.vue?vue&type=script&lang=js"
import style0 from "./FilterSalary.vue?vue&type=style&index=0&id=0acb28b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acb28b3",
  null
  
)

export default component.exports